import {
  setLoader,
  unSetLoader,
  setErrorMessage,
} from "store/actions/appActions";
import { billing } from "store/requests";

export const getChargeEntryNotes = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getChargeEntryNotes",
        payload,
        addUserName: true,
      });
      return data.success;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const addChargeEntryNote = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/addChargeEntryNote",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

// OLD NOTES : NOT IN USE

export const getNotesDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/getNotesDetails",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const addNotesDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/addNotesDetails",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const updateNotesDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/updateNotesDetails",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};
